import { formatDate } from '@/utils';
import {
  http,
  defaultConfig,
  SAMIN_KEY,
  SAMIN_WRITE_KEY,
  getFeedbackURL
} from './http';
import { TFunction } from 'i18next';

const baseURL = getFeedbackURL();

const DEFAULT_PROJECT_ID = 183;

export const fetchFeedbacks = async (profile: UserProfileEntity, university: UniversityEntity) => {
  return http.get('/issues.json', {
    ...defaultConfig(baseURL),
    timeout: 60000 * 2,
    params: {
      key: SAMIN_KEY,
      project_id: '183',
      cf_72: profile?.username,
      cf_70: university?.universityLabel,
      sort: 'start_date:desc',
      limit: 100
    },
  });
};

export const createFeedback = async (issue: Partial<RedmineIssueEntity>, profile: UserProfileEntity, university: UniversityEntity, t: TFunction) => {
  return http.post<any, any>('/issues.json', {
    issue: {
      ...issue,
      project_id: university?.services?.feedbackProjectId ?? DEFAULT_PROJECT_ID,
      status_id: 20,
      category_id: issue.category,
      tracker_id: issue.tracker,
      custom_fields: getCustomFields(profile, university, t),
      limit: 100
    }
  }, {
    ...defaultConfig(baseURL),
    params: { key: SAMIN_WRITE_KEY }
  });
};

const getCustomFields = (profile: UserProfileEntity, university: UniversityEntity, t: TFunction) => {

  const unknown = t('common:labels.unknown');
  const yes = t('common:labels.yes');
  const no = t('common:labels.no');

  return [
    { id: 70, value: university?.universityLabel },
    { id: 72, value: profile?.username },
    { id: 91, value: `${profile.firstName} ${profile.lastName}` },
    { id: 92, value: profile.mobileNumber },
    { id: 93, value: profile.email },
    {
      id: 94,
      value: profile.student?.hasOwnProperty('isDormitoryResident') ? profile.student?.isDormitoryResident ? yes : no : unknown,
    },
    { id: 117, value: profile?.fatherName ?? unknown },
    { id: 118, value: profile?.gender ?? unknown },
    {
      id: 119,
      value: profile.hasOwnProperty('enabled') ? profile.enabled ? yes : no : unknown,
    },
    { id: 120, value: profile?.nationalCode ?? unknown },
    { id: 121, value: (profile?.personnel != null) ? profile?.personnel ? yes : no : unknown },
    { id: 122, value: (profile?.faculty != null) ? profile?.faculty ? yes : no : unknown },
    { id: 123, value: profile?.birthDate ? formatDate(profile.birthDate) : unknown },
    { id: 124, value: profile?.address ?? unknown },
    { id: 125, value: profile?.postalCode ?? unknown },
    { id: 126, value: profile?.mobileNumber ?? unknown },
    { id: 127, value: profile?.shenasnameNumber ?? unknown },
    { id: 128, value: profile?.birthPlace ?? unknown },
    { id: 129, value: profile?.issuePlace ?? unknown },
    // 130 تاریخ صدور
    { id: 131, value: profile?.marriageStatus?.name ?? unknown, },
    { id: 132, value: profile?.province?.name ?? unknown },
    { id: 133, value: profile?.city?.name ?? unknown },
    { id: 134, value: profile?.militaryServiceStatus?.name ?? unknown },
    { id: 135, value: profile?.religion?.name ?? unknown },
    // 136 ملیت
    { id: 137, value: profile?.username ?? unknown },
    { id: 138, value: profile.student?.semester ?? unknown },
    { id: 139, value: profile?.student?.entranceType ?? unknown },
    { id: 140, value: profile?.student?.studyLevel?.name ?? unknown },
    { id: 141, value: profile?.student?.studyMajor?.name ?? unknown },
    { id: 142, value: profile?.student?.studyMajor?.description ?? unknown },
    { id: 143, value: profile?.student?.educationalStatus?.name ?? unknown },
    { id: 144, value: profile?.student?.passedSemesters ?? unknown },
  ];

};
